
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="py-5 text-center">
      <Container>
        <Row className="justify-content-center">
          <Col md={10}>
            <h2>Let's Connect</h2>
            <p className="lead">I'm always open to discussing new opportunities and collaborations.</p><br/>
            <Button href="mailto:andrei@skopenko.net" variant="primary" size="lg">Email Me</Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
